// Copyright (c) 2021 WiseTime. All rights reserved.

import React from "react"
import styled, { css } from "styled-components/macro"
import DateTabs from "./DateTabs"
import NavArrow from "./NavArrow"
import DateTabsTrash from "./DateTabsTrash"
import NavArrowTrash from "./NavArrowTrash"
import Calendar from "./Calendar"
import { isIosWiseTime } from "../../../app/config"

const Bar = styled.div`
  display: flex;
  align-items: center;
  background-color: ${({ theme }): string => theme.colors.gallery};
  border-bottom: 1px solid ${({ theme }): string => theme.colors.silverChalice};
  ${({ theme }) => isIosWiseTime && css`
    border-top: 1px solid ${theme.colors.silverChalice};
  `};

  @media (max-width: ${({ theme }): string => theme.screen.md}) {
    padding-left: 4.4rem;
  }
`

type Props = {
  isTrashView?: boolean,
}

const CalendarBar = ({ isTrashView = false }: Props): React.ReactElement => (
  <Bar>
    {isTrashView ? (
      <>
        <NavArrowTrash toPrevDate/>
        <DateTabsTrash/>
        <NavArrowTrash toPrevDate={false}/>
      </>
    ) : (
      <>
        <NavArrow toPrevDate/>
        <DateTabs/>
        <NavArrow toPrevDate={false}/>
        <Calendar/>
      </>
    )}
  </Bar>
)

export default CalendarBar
